module.exports = __webpack_public_path__ + "img/DOT.d401fe4e.png";